import { ROUTES } from '../../../../../constants/RouteNameMapping';

export const CONFIG_ROUTE = `${ROUTES.ADMIN_PANEL}/${ROUTES.CONFIG}`;
